'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setThreadId = undefined;

var _setIn = require('transmute/setIn');

var _setIn2 = _interopRequireDefault(_setIn);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setThreadId = exports.setThreadId = (0, _setIn2.default)(_keyPaths.THREAD_ID);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/setThreadId.js
// module id = 237
// module chunks = 2 3